







































import { defineComponent, ref } from '@vue/composition-api';

import CommonDropzoneWithAxios from '@/components/Dropzone/CommonDropzoneWithAxios.vue';

import useAxios from '@/useAxios';

const SponsorItem = defineComponent({
  components: {
    CommonDropzoneWithAxios,
  },
  props: {
    index: { default: -1 },
    value: {
      default: () => ({
        id: -1,
        name: '',
        url: '',
        logo: '',
      }),
    },
  },
  setup(props, { emit }) {
    const { axios } = useAxios();

    function updateNameHandler(e: any) {
      emit('input', {
        ...props.value,
        name: e,
      });
    }
    function updateUrlHandler(e: any) {
      emit('input', {
        ...props.value,
        url: e,
      });
    }

    return {
      axios,
      updateNameHandler,
      updateUrlHandler,
    };
  },
});

export default SponsorItem;
